import { resetNatureOfBusiness, setNatureOfBusiness } from '../../../../../features/gms-proposal-forms/basic-information/basic-information.slice';
import { useDispatch } from 'react-redux';
import { GroupedIndustriesResponse } from '../../../../../types/type';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';

interface Props {
    industries: GroupedIndustriesResponse | undefined;
    setView: (value: 'category' | 'item') => void;
}

export default function IndustriesCategory({ industries, setView }: Props) {
    const dispatch = useDispatch();
    const { natureOfBusinessCategory  } = useProposalTypeData()

    const handleSelectCategory = (id: number, name: string) => {
        dispatch(setNatureOfBusiness({ type: 'category', value: { id, name } }));
        dispatch(resetNatureOfBusiness({ type: 'item' }));
    };

    return (
        <div className="grid grid-cols-2 gap-3">
            {industries &&
                Object.entries(industries).map(([category, items]) => {
                    const id = items?.[0]?.parent_id ?? 0;

                    return (
                        <label
                            key={category}
                            className={`gap-2 flex px-3 py-2 rounded border transition-all duration-200 items-center cursor-pointer bg-white text-center capitalize ${natureOfBusinessCategory?.id === id ? 'border-[#186cb2] bg-blue-50' : 'border-gray-300 hover:border-[#186cb2] hover:bg-gray-100'}`}
                        >
                            <input
                                type="checkbox"
                                onClick={() => {
                                    setView('item');
                                    handleSelectCategory(id, category);
                                }}
                                className="hidden"
                            />

                            <span className="text-sm text-black flex-1 whitespace-normal break-words">
                                {category
                                    .replaceAll("_", " ")
                                    .toLowerCase()
                                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                            </span>
                        </label>
                    );
                })}
        </div>
    );
}